import React, { useState, useEffect } from "react";
import "./UserLimitPage.css";
import { useLocalSearch } from "../../hooks/useLocalSearch";
import { useToast } from './../../components/Toast/ToastContainer';

const UserLimitPage = () => {
    const toast = useToast();
    // State cho bộ lọc
    const [filters, setFilters] = useState({
        cifUser: "",
        idDaiLy: "",
        username: "",
        cifDaiLy: "",
    });

    // State dữ liệu và phân trang
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const [isLoading, setIsLoading] = useState(false);
    const { searchTerm, setSearchTerm, filteredData } = useLocalSearch(data);

    // Hàm format tiền tệ
    const formatCurrency = (value) => {
        if (!value) return "0";
        return new Intl.NumberFormat('vi-VN').format(parseFloat(value));
    };

    // Hàm gọi API
    const fetchData = async (page = 1) => {
        setIsLoading(true);
        try {
            // Lấy token từ localStorage
            const token = localStorage.getItem("access_token");

            const payload = {
                user_cif: filters.cifUser || "",
                username: filters.username || "",
                agent_id: filters.idDaiLy || "",
                agent_cif: filters.cifDaiLy || "",
                page: page,
                page_size: pageSize
            };

            const response = await fetch('https://api.bvb.cybertech.com.vn/api/v1/admin/queries/users/limits', {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                // Nếu token hết hạn hoặc lỗi server (401, 500...)
                if (response.status === 401) {
                    console.error("Token hết hạn hoặc không hợp lệ");
                    // Có thể điều hướng về trang login nếu cần
                }
                throw new Error("Lỗi API");
            }

            const result = await response.json();
            console.log("ket qua user limit", result);

            setData(result.data || []);
            setTotalRecords(result.total || 0);
            setCurrentPage(page);

        } catch (error) {
            console.error("Failed to fetch user limits:", error);
            // Không dùng alert() ở đây để tránh popup khi F5 lỗi mạng
            setData([]);
            setTotalRecords(0);
        } finally {
            setIsLoading(false);
        }
    };

    // // Gọi API khi component load lần đầu
    // useEffect(() => {
    //     fetchData(1);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const handleSearch = () => {
        // Kiểm tra xem có ít nhất một trường filter được nhập hay không
        const hasFilter = Object.values(filters).some(value => value.trim() !== "");

        if (!hasFilter) {
            toast.error("Vui lòng nhập ít nhất một thông tin để tìm kiếm.");
            return;
        }

        fetchData(1);
    };

    const handleReset = () => {
        setFilters({ cifUser: "", idDaiLy: "", username: "", cifDaiLy: "" });
        // Reset xong load lại dữ liệu gốc (có thể bỏ dòng dưới nếu muốn reset xong phải bấm tìm kiếm mới load)
        setTimeout(() => fetchData(1), 0);
    };

    const handlePageChange = (newPage) => {
        const totalPages = Math.ceil(totalRecords / pageSize);
        if (newPage > 0 && newPage <= totalPages) {
            fetchData(newPage);
        }
    };

    const totalPages = Math.ceil(totalRecords / pageSize);

    return (
        <div className="user-limit-container">
            <h2 className="page-title">Truy vấn hạn mức Ngày/User</h2>

            {/* FORM TÌM KIẾM */}
            <div className="filter-card">
                <div className="filter-grid">
                    <div className="filter-item">
                        <label>CIF user</label>
                        <input
                            type="text"
                            name="cifUser"
                            value={filters.cifUser}
                            onChange={handleChange}
                            placeholder="Nhập CIF user"
                        />
                    </div>

                    <div className="filter-item">
                        <label>ID Đại lý</label>
                        <input
                            type="text"
                            name="idDaiLy"
                            value={filters.idDaiLy}
                            onChange={handleChange}
                            placeholder="Nhập ID đại lý"
                        />
                    </div>

                    <div className="filter-item">
                        <label>Username</label>
                        <input
                            type="text"
                            name="username"
                            value={filters.username}
                            onChange={handleChange}
                            placeholder="Nhập username"
                        />
                    </div>

                    <div className="filter-item">
                        <label>CIF Đại lý</label>
                        <input
                            type="text"
                            name="cifDaiLy"
                            value={filters.cifDaiLy}
                            onChange={handleChange}
                            placeholder="Nhập CIF đại lý"
                        />
                    </div>
                </div>

                <div className="filter-actions">
                    <button className="btn-secondary" onClick={handleReset}>
                        Xóa lọc
                    </button>
                    <button className="btn-primary" onClick={handleSearch} disabled={isLoading}>
                        {isLoading ? "Đang tìm..." : "Tìm kiếm"}
                    </button>
                </div>
            </div>

            {/* KẾT QUẢ TÌM KIẾM */}
            <div className="result-header">
                <h3 className="result-title">Kết quả tìm kiếm</h3>
                <div className="search-inline">
                    <img src="/icons/icons8-search-100.png" alt="search icon" className="search-icon" />
                    <input
                        type="text"
                        placeholder="Tìm kiếm nhanh trong bảng..."
                        value={searchTerm} // 1. Gắn giá trị vào state
                        onChange={(e) => setSearchTerm(e.target.value)} // 2. Khi gõ thì cập nhật state
                    />
                </div>
            </div>

            {/* TABLE */}
            <div className="table-wrapper">
                <table className="result-table">
                    <thead>
                        <tr>
                            <th>CIF user</th>
                            <th>Username</th>
                            <th>HM nộp được cấp</th>
                            <th>Số tiền đã nộp</th>
                            <th>HM rút được cấp</th>
                            <th>Số tiền đã rút</th>
                            <th>CIF Đại lý</th>
                            <th>ID Đại lý</th>
                        </tr>
                    </thead>

                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>Đang tải dữ liệu...</td>
                            </tr>
                        ) : filteredData.length > 0 ? (
                            filteredData.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.user_cif}</td>
                                    <td>{row.username}</td>
                                    <td className="text-right">{formatCurrency(row.daily_deposit_limit)}</td>
                                    <td className="text-right">{formatCurrency(row.daily_deposit_usage)}</td>
                                    <td className="text-right">{formatCurrency(row.daily_withdraw_limit)}</td>
                                    <td className="text-right">{formatCurrency(row.daily_withdraw_usage)}</td>
                                    <td>{row.agent_cif}</td>
                                    <td>{row.agent_id}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>{/* Logic hiển thị thông báo */}
                                    {data.length > 0 && searchTerm
                                        ? "Không tìm thấy kết quả phù hợp"
                                        : "Không có dữ liệu"}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* PAGINATION */}
            {totalRecords > 0 && (
                <div className="pagination">
                    <span>
                        {/* Format: [Số dòng hiện tại] / [Tổng số bản ghi] */}
                        Số lượng bản ghi: {filteredData.length}/{totalRecords} ({pageSize} bản ghi/trang)
                    </span>
                    <div className="pager">
                        <button
                            disabled={currentPage === 1 || isLoading}
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            Trước
                        </button>
                        <button className="active">{currentPage}</button>
                        <button
                            disabled={currentPage === totalPages || isLoading}
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            Sau
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserLimitPage;